import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const ChangeEmailCard = ({ onChanged }) => {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ new_email: "", current_password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/change-email", f);
      setUser(data);
      setF({ new_email: "", current_password: "" });
      toast.success(`Login email changed to ${data.email}`);
      onChanged();
    } catch (e2) { toast.error(formatErr(e2)); }
    setBusy(false);
  };

  return (
    <form onSubmit={submit} data-testid="change-email-form" className="bg-white border rounded-xl p-4 space-y-3">
      <div>
        <p className="font-semibold flex items-center gap-2"><Mail className="w-4 h-4" />My login email</p>
        <p data-testid="current-admin-email" className="text-xs text-slate-500 font-mono">Current: {user.email}</p>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        <Input data-testid="new-admin-email" type="email" required placeholder="New email" value={f.new_email} onChange={(e) => setF({ ...f, new_email: e.target.value })} />
        <Input data-testid="change-email-password" type="password" required placeholder="Current password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
        <Button data-testid="change-email-btn" disabled={busy} className="bg-sky-600 hover:bg-sky-700">Update email</Button>
      </div>
    </form>
  );
};
